import SFAuthService, { NO_USER } from 'app/services/sfAuth/SFAuthService'

export const getAccessLevelToObject = async (
  { type, id }: { type: string, id: string }
): Promise<any> => {
  const conn = SFAuthService.getConnection()
  if (conn == null) {
    return await Promise.reject(NO_USER)
  }
  return conn.sobject(type)
    .find({
      Id: id
    })
    .select(
      ['Id',
        'UserRecordAccess.HasEditAccess',
        'UserRecordAccess.HasReadAccess',
        'UserRecordAccess.MaxAccessLevel'
      ].join(', ')
    )
    .then(result => result[0]?.UserRecordAccess)
}
